// @flow
import React from 'react';
import type { HomePratiques } from 'types/Settings';
import type { FullUserType } from 'types/User';
import BackgroundImage from 'components/fragments/BackgroundImage';
import LazyLoad from 'components/fragments/LazyLoad';
import { handleTagEvent } from 'utils/tagManagerUtils';

export type StateProps = {
  trouver_pratiques: HomePratiques,
  userPref: FullUserType
};

const HubTrouverRugby = (props: StateProps) => {
  const { trouver_pratiques: { titre_liste, bloc_principal, pratiques }, userPref } = props;

  return (
    bloc_principal.object_id &&
      <LazyLoad>
        <section className="container section">
          <h2 className="mb-3">{titre_liste}</h2>
          <div className="row">
            <div className="col col-md-4 mb-2 mb-lg-0">
              <a href={bloc_principal.slug_complet} title={bloc_principal.title} className="box card card--hub-alt">
                <BackgroundImage
                  className="card__thumbnail img-blue-dark"
                  illustration={bloc_principal.featured_image && bloc_principal.featured_image.src}
                  srcset={bloc_principal.featured_image && bloc_principal.featured_image.sizes}
                  />
                <div className="card__body">
                  <h3 className="card__title">
                    {bloc_principal.texte_cta ? bloc_principal.texte_cta : bloc_principal.title}
                  </h3>
                  <p className="card__desc ft-secondary">{bloc_principal.description}</p>
                </div>
                <div className="card__footer">
                  <span className="btn btn--cheer">
                    <i className="icon icon-chevron-right link-icon is-dark is-inline"></i>
                    <span>Consulter</span>
                  </span>
                </div>
              </a>
            </div>
            <div className="col col-md-8 mb-2 mb-lg-0">
              <div className="box box--white">
                {pratiques.pratique_5 &&
                  <a
                    href={pratiques.pratique_5.slug_complet ? pratiques.pratique_5.slug_complet : '#'}
                    className="rugby-type"
                    onClick={handleTagEvent(
                      "homepage",
                      "Rugby à 5",
                      '',
                      userPref
                    )}>
                    <div className="rugby-type__logo">5</div>
                      <div className="rugby-type__name">Rugby à 5</div>
                      <span className="link-icon">
                        <i className="icon icon-chevron-right"></i>
                      </span>
                  </a>
                }
                {pratiques.pratique_7 &&
                  <a
                    href={pratiques.pratique_7.slug_complet ? pratiques.pratique_7.slug_complet : '#'}
                    className="rugby-type"
                    onClick={handleTagEvent(
                      "homepage",
                      "Rugby à 7",
                      '',
                      userPref
                    )}>
                    <div className="rugby-type__logo">7</div>
                    <div className="rugby-type__name">Rugby à 7</div>
                    <span className="link-icon">
                      <i className="icon icon-chevron-right"></i>
                    </span>
                  </a>
                }
                {pratiques.pratique_10 &&
                  <a
                    href={pratiques.pratique_10.slug_complet ? pratiques.pratique_10.slug_complet : '#'}
                    className="rugby-type"
                    onClick={handleTagEvent(
                      "homepage",
                      "Rugby à 10",
                      '',
                      userPref
                    )}>
                    <div className="rugby-type__logo">10</div>
                    <div className="rugby-type__name">Rugby à 10</div>
                    <span className="link-icon">
                      <i className="icon icon-chevron-right"></i>
                    </span>
                  </a>
                }
                {pratiques.pratique_15 &&
                  <a
                    href={pratiques.pratique_15.slug_complet ? pratiques.pratique_15.slug_complet : '#'}
                    className="rugby-type"
                    onClick={handleTagEvent(
                      "homepage",
                      "Rugby à 15",
                      '',
                      userPref
                    )}>
                    <div className="rugby-type__logo">XV</div>
                    <div className="rugby-type__name">Rugby à XV</div>
                    <span className="link-icon">
                      <i className="icon icon-chevron-right"></i>
                    </span>
                  </a>
                }
              </div>
            </div>
          </div>
        </section>
      </LazyLoad>
  );
};

export default HubTrouverRugby;
